import {
  CustomizationSelectedIngredient,
  CustomizationSelectedIngredientsContainer,
  CustomizationSelectedIngredientsList,
  CustomizationSelectedIngredientsListItem,
} from './components';

export const CustomizationSelectedIngredients = {
  Container: CustomizationSelectedIngredientsContainer,
  List: CustomizationSelectedIngredientsList,
  ListItem: CustomizationSelectedIngredientsListItem,
  Ingredient: CustomizationSelectedIngredient,
};
